import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { ChartData } from "./types";

interface KPICardProps {
  data: ChartData;
}

export default function KPICard({ data }: KPICardProps) {
  if (data.rows.length === 0) {
    return (
      <Card>
        {data.title && <CardHeader title={data.title} />}
        <CardContent>
          <Typography variant="body2">データなし</Typography>
        </CardContent>
      </Card>
    );
  }

  const firstRow = data.rows[0];
  const numericKey = data.columns.find(
    (col) => typeof firstRow[col] === "number"
  );
  const value = numericKey != null ? firstRow[numericKey] : Object.values(firstRow)[0];

  return (
    <Card>
      {data.title && <CardHeader title={data.title} />}
      <CardContent>
        <Typography variant="h3" align="center">
          {String(value ?? "")}
        </Typography>
        {numericKey && (
          <Typography variant="body2" align="center" color="text.secondary">
            {numericKey}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
